import React from 'react';
import { Box, Grid, IconButton, Stack, Typography } from '@mui/material';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { EditType } from '../types';

interface KeyRequirementsPanelProps {
  keyRequirements: string[];
  isEditing: boolean;
  isLoadingImplementation: boolean;
  onEdit: (type: EditType, item?: any) => void;
}

const KeyRequirementsPanel: React.FC<KeyRequirementsPanelProps> = ({
  keyRequirements,
  isEditing,
  onEdit,
}) => (
  <Box sx={{ height: 'max-content', display: 'flex', flexDirection: 'column' }}>
    {/* Panel header */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: '3rem',
        bgcolor: '#1A55F9',
        color: 'white',
        justifyContent: 'space-between',
        px: 2,
        py: 1,
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        fontWeight: 'bold',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <img src="/images/Info_implement_info.svg" style={{ marginRight: '8px' }} alt="" />
        <Typography>Key Requirements</Typography>
      </Box>
      {isEditing && (
        <IconButton size="small" onClick={() => onEdit('add_key_requirements')}>
          <AddBoxOutlinedIcon sx={{ color: 'white' }} />
        </IconButton>
      )}
    </Box>

    {/* Panel body */}
    <Stack
      spacing={2}
      alignItems="baseline"
      justifyContent="flex-start"
      sx={{ flexGrow: 1, px: { xs: 1.5, sm: 3 }, py: { xs: 2, sm: 3 }, border: '1px solid #ccc' }}
    >
      {keyRequirements.length > 0 ? (
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Box>
              {keyRequirements.map((item: string, idx: number) => (
                <Box
                  key={idx}
                  sx={{ display: 'flex', alignItems: 'flex-start', my: 1, minWidth: 0 }}
                >
                  <Box sx={{ pt: '3px', flexShrink: 0, mr: 1 }}>
                    <img src="/images/Info_implement.svg" alt="" />
                  </Box>
                  <Typography
                    variant="body1"
                    sx={{ display: 'block', whiteSpace: 'pre-line', textAlign: 'left', m: 0 }}
                  >
                    {item}
                    {isEditing && (
                      <DriveFileRenameOutlineIcon
                        sx={{ cursor: 'pointer', height: '16px', width: '16px', color: 'grey.500' }}
                        onClick={() => onEdit('key_requirements', { index: idx, name: item })}
                      />
                    )}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 12 }}>
            <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
              No key requirements available
            </Typography>
          </Grid>
        </Grid>
      )}
    </Stack>
  </Box>
);

export default KeyRequirementsPanel;
